import { Tooltip, Typography } from '@mui/material';
import { find } from 'lodash';
import React from 'react';
import { KeyValue } from 'sr-types/lib/production/v1/graphql';
import { useStyling } from '../../common/Theme';
import EllipsisText from '../../common/components/EllipsisText';
import I18n from '../../common/i18n/I18n';

const Component = ({ otherTitles, onClick }: { otherTitles: KeyValue[] | string; onClick?: () => void }) => {
    const { theme } = useStyling();
    const aka =
        typeof otherTitles === 'string'
            ? { key: 'AKA', value: otherTitles }
            : Array.isArray(otherTitles)
              ? find(otherTitles, { key: 'AKA' })
              : undefined;

    return aka ? (
        <>
            <Typography variant="h6" sx={{ fontSize: '14px', color: theme.palette.text.disabled }}>
                <I18n token="production.aka" />
            </Typography>
            <Tooltip title={<Typography fontSize="small"> {aka.value}</Typography>} onClick={onClick}>
                <EllipsisText text={aka.value} sx={{ fontSize: theme.typography.body1.fontSize, textWrap: 'nowrap' }} />
            </Tooltip>
        </>
    ) : (
        <></>
    );
};
Component.displayName = 'AkaLabel';
export default Component;
